/* ============================================
   NODUS · UNBOXING VIDEOS
   Click-to-play tiles: the <video> stays in a <template> until requested
   so a grid of clips never costs anything on first paint.
   ============================================ */

if (!customElements.get('nodus-unboxing-tile')) {
	class NodusUnboxingTile extends HTMLElement {
		connectedCallback() {
			this.trigger = this.querySelector('[data-nodus-unboxing-play]');
			this.template = this.querySelector('[data-nodus-unboxing-video]');

			if (!this.trigger || !this.template) return;

			this.handleClick = this.play.bind(this);
			this.trigger.addEventListener('click', this.handleClick);
		}

		disconnectedCallback() {
			if (this.trigger && this.handleClick) this.trigger.removeEventListener('click', this.handleClick);
		}

		play() {
			const content = this.template.content.cloneNode(true);
			const video = content.querySelector('video');

			this.trigger.remove();
			this.template.remove();
			this.appendChild(content);

			if (video) {
				video.setAttribute('playsinline', '');
				video.play().catch(() => {
					// Autoplay can be refused by the browser; the native controls remain usable.
				});
			}
		}
	}

	customElements.define('nodus-unboxing-tile', NodusUnboxingTile);
}
